import { isFeature } from '../isFeature'
import { isValidFeatureCollection } from '../isFeatureCollection'

const nonGeoTypes = {
  Feature: isFeature,
  FeatureCollection: isValidFeatureCollection
}

export { nonGeoTypes }
